// const GlobalAPI = "http://172.16.25.245:3030";
const GlobalAPI = "https://jianglab.biodesign.ac.cn";
export default  GlobalAPI;